import { TextShimmer } from "@/components/text-shimmer";
import { useAppSelector } from "@/redux/hooks";
import { FilterX } from "lucide-react";
import { Suspense, memo } from "react";
import HotelFilterPopover from "./hotel-filter-popover";
import { HotelSearchTimer } from "./hotel-search-timer";

import { HotelFilterSection } from "./hotel-filter";

export const HotelFilterSidebar = memo(() => {
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );

  return (
    <div className="sticky top-[calc(var(--header-height)+4rem)] z-30 lg:flex lg:h-[calc(100svh-var(--header-height)-4.1rem)] w-full self-start overscroll-none  lg:w-5/12 xl:w-[28%] ">
      <div className="hidden lg:flex lg:flex-col w-full">
        <div className="border border-t-0! z-20  pt-3 rounded-b-lg bg-card">
          <div className="flex justify-between items-end pl-4 pr-2 py-1">
            <div>
              <span className="font-bold text-xs md:text-lg">
                {isLoading ? (
                  <TextShimmer>Searching hotels...</TextShimmer>
                ) : (
                  "Hotel Search"
                )}
              </span>
            </div>
            <Suspense
              fallback={
                <span className="tabular-nums text-xs text-muted-foreground">
                  --:--
                </span>
              }
            >
              <HotelSearchTimer />
            </Suspense>
          </div>
        </div>

        <div className="bg-card mt-3 rounded-t-lg border h-full overflow-auto no-scrollbar">
          <div className="flex items-center justify-between gap-2 pl-4 py-2 sticky top-0 z-20  border-b bg-card">
            <div className="flex items-center gap-2">
              <FilterX className="h-3.5 w-3.5 text-muted-foreground" />
              <span className="font-semibold">Filters</span>
            </div>
            <HotelFilterPopover />
          </div>
          <HotelFilterSection />
        </div>
      </div>
    </div>
  );
});

HotelFilterSidebar.displayName = "HotelFilterSidebar";
